import { createUserFileService } from './userFileService';

// Player data files live in the per-user 'playerdata' S3 namespace.
const service = createUserFileService('playerdata', 'player data file');

export const savePlayerDataFile = service.save;
export const listPlayerDataFiles = service.list;
export const loadPlayerDataFile = service.load;
export const deletePlayerDataFile = service.remove;
export const renamePlayerDataFile = service.rename;
